const sampleCsvData = [
  {
    nationalId: '1107454009',
    freelancerNumber: 'FL-013988291',
  },
  {
    nationalId: '1107454009',
    freelancerNumber: 'FL-595215341',
  },
];

const freelancerSampleCsvFile = {
  fileName: 'freelancer-verification-bulk-upload.csv',
  sampleCsvData,
};

export { freelancerSampleCsvFile };

